import { Variants } from "framer-motion";

export const scrollAnimation: Variants = {
  offscreen: {
    y: -300,
    opacity: 0,
  },
  onscreen: ({ duration = 2 } = {}) => ({
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration,
    },
  }),
};
export const scrollAnimationBottom: Variants = {
  offscreen: {
    y: 300,
    opacity: 0,
  },
  onscreen: ({ duration = 2 } = {}) => ({
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration,
    },
  }),
};

export const scrollAnimationHeader: Variants = {
  offscreen: {
    y: 40, // Starts 50px lower
    opacity: 0,
  },
  onscreen: ({ duration = 2 } = {}) => ({
    y: 0, // Moves up to original position
    opacity: 1,
    transition: {
      type: "spring",
      duration,
    },
  }),
};
